import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { WINDOW, WindowService } from '@core/index';
import { fromEvent as observableFromEvent } from 'rxjs';

import { FLIGHT_TRACKER_CONFIG } from '../../flight-tracker.config';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'jb-flight-tracker-mobile-alert-label',
  templateUrl: './flight-tracker-mobile-alert-label.component.html',
  styleUrls: ['./flight-tracker-mobile-alert-label.component.scss'],
})
export class FlightTrackerMobileAlertLabelComponent
  implements OnInit, AfterViewInit
{
  @Input('mobileAlertCopy') mobileAlertCopy;
  @Input('lowerLabel') lowerLabel = false;
  @Output() headerHidden: EventEmitter<boolean> = new EventEmitter();

  offsetTop: number;
  lastScroll = 0;
  headerSize = 120;
  appLinks: any;
  mobileLink: string;

  constructor(
    private elementRef: ElementRef,
    private windowService: WindowService,
    @Inject(WINDOW) private window: any,
  ) {
    this.windowService.windowSizeChanged.subscribe(size => {
      this.headerSize = !!size.small ? 120 : 220;
    });
    this.appLinks = FLIGHT_TRACKER_CONFIG.MOBILE_APP_LINKS;
  }

  ngOnInit() {
    this.mobileLink = this.appLinks.otherLink;
  }

  ngAfterViewInit() {
    if (this.lowerLabel) {
      const element = this.elementRef.nativeElement;
      this.offsetTop = element.offsetTop - this.headerSize;
      observableFromEvent(this.window, 'scroll').subscribe(() => {
        this.manageScrollEvent();
      });
    }
  }

  manageScrollEvent(): void {
    const scroll = this.window.pageYOffset;

    if (scroll > this.lastScroll && scroll >= this.offsetTop) {
      this.hideHeader();
    } else if (scroll < this.lastScroll && scroll <= this.offsetTop) {
      this.showHeader();
    }

    this.lastScroll = scroll;
  }

  hideHeader(): void {
    this.headerHidden.emit(true);
  }

  showHeader(): void {
    this.headerHidden.emit(false);
  }
}
